import type { ReactNode } from "react";

export interface Stat {
  label: string;
  value: ReactNode;
  /** small trailing unit/qualifier shown after the value (e.g. "boards", "today") */
  sub?: ReactNode;
}

/** A row of headline stat cards over the shared `.stat-grid` / `.stat-card` primitives. */
export function StatStrip({ stats }: { stats: Stat[] }) {
  return (
    <div className="stat-grid">
      {stats.map((s, i) => (
        <div className="card stat-card" key={i}>
          <div className="lbl">{s.label}</div>
          <div className="val mono">
            {s.value}
            {s.sub != null && <small> {s.sub}</small>}
          </div>
        </div>
      ))}
    </div>
  );
}
